export default __webpack_public_path__ + "static/media/contest-selected.187953a4.svg";